<template>
  <div>
    <!-- Mini drawer -->
    <v-navigation-drawer
      v-model="showMiniDrawer"
      v-if="$vuetify.breakpoint.mdAndUp"
      absolute
      stateless
      app
      mini-variant
      mini-variant-width="56"
      class="primary elevation-4 map-mini-drawer"
    >
      <v-tooltip right>
        <template v-slot:activator="{ on }">
          <v-btn
            @click="toggleAppDrawer"
            fab
            dark
            small
            aria-label="Vis hovedmeny"
            label="Vis hovedmeny"
            flat
            v-on="on"
            color="white"
            class="white--text"
          >          
            <v-icon class="drawer-icon" dark>menu</v-icon>
            
          </v-btn>
        </template>
        <span>Meny</span>
      </v-tooltip>

      <left-sidebar-item-toggle
        v-for="(item, name) in tools"
        v-show="
          !item.hasOwnProperty('hideInMenus') || item.hideInMenus === false
        "
        :key="name"
        :name="name"
        :icon="item.icon"
        :data-v-step="name"
        :text="item.text"
        :active="item.active"
        :title="item.title"        
        @toggle-tool="toggleContent"
      />

      <img alt="NVE logo"
        style="bottom: 10px; left: 8px;z-index: 100000; position: absolute; height: 50px;"
        :src="getImgUrl(logoImagePath)"
      />
    </v-navigation-drawer>

    <!-- Sidebar content -->
    <v-navigation-drawer
      :app="$vuetify.breakpoint.mdAndUp"
      :stateless="$vuetify.breakpoint.mdAndUp"
      class="elevation-8 left-sidebar"
      disable-resize-watcher
      :temporary="!$vuetify.breakpoint.mdAndUp"
      absolute
      :width="leftSidebarWidth"
      id="scroll-target"
      hide-overlay
      v-model="showSideMenu"
      color="whitesmoke"
    >
      <left-sidebar-item>
        <layer-list v-show="activeExclusiveToolName == 'layers'" />
        <map-search
          v-if="mapLoaded"
          v-show="activeExclusiveToolName == 'search'"
        />
        <map-print
          v-if="mapLoaded && $vuetify.breakpoint.mdAndUp"
          v-show="activeExclusiveToolName == 'print'"
        />
        <map-bookmarks v-show="activeExclusiveToolName == 'bookmarks'" />
        <tips-and-tricks
          v-if="mapLoaded"
          v-show="activeExclusiveToolName == 'help'"
        />
        <share-project-dialog
          :active="activeExclusiveToolName == 'share'"
        ></share-project-dialog>
      </left-sidebar-item>
    </v-navigation-drawer>
  </div>
</template>

<script>
import LayerList from "@/pages/MapPage/Tools/Layers/LayerList";

import ShareProjectDialog from "@/pages/MapPage/Tools/Sharing/ShareProjectDialog";

import LeftSidebarItemToggle from "@/pages/MapPage/Layout/LeftSidebarItemToggle";
import LeftSidebarItem from "@/pages/MapPage/Layout/LeftSidebarItem";
import { mapState, mapActions } from "vuex";

export default {
  name: "TheLeftSidebar",
  data: () => ({
    savedMaps: []
  }),
  components: {
    MapSearch: () => import("@/pages/MapPage/Tools/Searching/MapSearch"),
    LayerList,
    ShareProjectDialog,
    MapPrint: () => import("@/pages/MapPage/Tools/Printing/MapPrint"),
    LeftSidebarItem,
    LeftSidebarItemToggle,
    MapBookmarks: () => import("@/pages/MapPage/Tools/Bookmarks/MapBookmarks"),
    TipsAndTricks: () => import("@/pages/MapPage/Tools/Tips/TipsAndTricks")
  },
  watch: {
    showSideMenu: function(newVal) {
      if (!newVal && this.activeExclusiveToolName) {
        this.deactivateTool(this.activeExclusiveToolName);
        this.activeExclusiveToolName = "";
      }
    }
  },
  computed: {
    ...mapState([
      "tools",
      "sidebarHasOpened",
      "showAppDrawer",
      "mapLoaded",
      "logoImagePath"
    ]),
    showSideMenu: {
      set(showSideMenu) {
        this.setShowSideMenu(showSideMenu);
      },
      get() {
        return this.$store.state.showSideMenu;
      }
    },
    leftSidebarWidth() {
      if (this.$vuetify.breakpoint.xlAndUp) {
        return "486";
      } else if (this.$vuetify.breakpoint.lgAndUp) {
        return "400";
      } else if (this.$vuetify.breakpoint.mdAndUp) {
        return "350";
      } else if (this.$vuetify.breakpoint.smAndUp) {
        return "300";
      } else {
        return "300";
      }
    },
    showMiniDrawer: {
      set(showMiniDrawer) {
        this.setShowMiniDrawer(showMiniDrawer);
      },
      get() {
        return this.$store.state.showMiniDrawer;
      }
    },
    activeExclusiveToolName: {
      set(activeExclusiveToolName) {
        this.setActiveExclusiveToolName(activeExclusiveToolName);
      },
      get() {
        return this.$store.state.activeExclusiveToolName;
      }
    }
  },
  methods: {
    ...mapActions([
      "setShowAppDrawer",
      "setShowMiniDrawer",
      "setActiveExclusiveToolName",
      "deactivateTool",
      "activateTool",
      "setShowSideMenu"
    ]),
    toggleAppDrawer: function() {
      this.setShowAppDrawer(!this.showAppDrawer);
    },
    getImgUrl(svgName) {
      let images = require.context("../../../assets/", false, /\.(svg|png)$/);
      return images("./" + svgName);
    },
    toggleContent: function(toolName) {
      let newTool = this.tools[toolName];
      if (newTool.isMapTool && !newTool.exclusive) {
        this.toggleNonExclusiveMapTool(toolName);
      } else {
        if (this.$vuetify.breakpoint.mdAndUp || newTool.useSidebarOnMobile) {
          this.toggleExclusiveSidebarTool(toolName);
        }
      }
    },
    toggleNonExclusiveMapTool: function(toolName) {
      if (this.tools[toolName].active) {
        this.deactivateTool(toolName);
      } else {
        this.activateTool(toolName);
      }
    },
    toggleExclusiveSidebarTool(toolName) {
      if (this.activeExclusiveToolName) {
        if (this.activeExclusiveToolName == toolName) {
          this.hideTheSideMenu();
          this.deactivateTool(toolName);
          this.activeExclusiveToolName = "";
        } else {
          this.deactivateTool(this.activeExclusiveToolName);
          this.activeExclusiveToolName = toolName;
          this.activateTool(toolName);
        }
      } else {
        this.activeExclusiveToolName = toolName;
        this.activateTool(toolName);
        this.showTheSidemenu();
      }
    },
    hideTheSideMenu() {
      this.showSideMenu = false;
    },
    showTheSidemenu() {
      this.showSideMenu = true;
    },
    toggleSidemenu: function() {
      this.setShowSideMenu(!this.showSideMenu);
    }
  },
  created: function() {
    this.showSideMenu = this.$vuetify.breakpoint.mdAndUp;
    this.$eventHub.$on("toggle-tool", toolName => {
      this.toggleContent(toolName);
    });
  },
  beforeDestroy() {
    this.$eventHub.$off("toggle-tool");
  }
};
</script>
<style scoped>
.left-sidebar {
  z-index: 4;
}

.map-mini-drawer {
  left: 0px;
  top: 0px;
  bottom: 0px;
  z-index: 12;
}

.drawer-icon {
  font-size: 22px !important;
}
</style>
